import { AuthService } from 'src/app/shared/services/auth.service';
import { Component, OnInit, EventEmitter, Output, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { CampoAdicionalEntry } from 'src/app/shared/entrys/campo-adicional.entry';
import { TipoEstablecimientoService } from './tipo-establecimiento.service';
import { DocumentoModel } from 'src/app/shared/models/documento.model';
import { CompletaInformacionService } from '../completa-informacion/completa-informacion.service';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { FormBuilder, FormControl, Validators, FormGroup, AbstractControl } from '@angular/forms';
import { TipoPrestador } from 'src/app/shared/enumeraciones/tipo-prestador.enum';
import { TurismoAventuraEntry } from 'src/app/shared/entrys/turismo-aventura.entry';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
// tslint:disable-next-line:max-line-length
import { ConfirmarRespuestaModel, ConfirmarRespuestaType, TipoConfirmacionModalType } from 'src/app/shared/models/confirmar-respuesta.model';
import { RatificaInformacionEntry } from 'src/app/shared/entrys/ratificacion-informacion.entry';
import { TipoCampoAdicional } from 'src/app/shared/enumeraciones/tipo-campo-adicional.enum';
import { ConfirmeValidators } from 'src/app/shared/directives/validators/confirme-validators';
import { DocumentoEntry } from 'src/app/shared/entrys/documento.entry';
import { TipoRnt } from 'src/app/shared/enumeraciones/tipo-rnt.enum';
import { AyudasService } from 'src/app/components/contenido/containers/ayudas/ayudas.service';
import { CamposAdicionalesEnum } from 'src/app/shared/enumeraciones/campos-adicionales.enum';
import { ModalArriendoVehiculoComponent } from 'src/app/components/core/layouts/modal-arriendo-vehiculo/modal-arriendo-vehiculo.component';
import { AlertsService } from 'src/app/shared/services/alerts.service';
import { TipoSolicitud } from 'src/app/shared/enumeraciones/tipo-solicitud.enum';
import { DatoPaginadoModel } from 'src/app/shared/models/dato-paginado.model';
import { DomSanitizer } from '@angular/platform-browser';

import { PlataformasElectronicasDigitalesFlow } from 'src/app/shared/flows/plataformas-electronicas-digitales.flow';
import { TipoPrestadorId } from 'src/app/shared/enumeraciones/tipo-prestador-id.enum';
import { EstablecimientoEntry } from 'src/app/shared/entrys/establecimiento.entry';

import { BasicasLoVService } from "src/app/shared/services/basicas-lov.service";
import { TipoIdentificacionEntry } from 'src/app/shared/entrys/tipo_identificacion.entry';
import { DepartamentoEntry } from "./../../../../../../../shared/entrys/departamento.entry";
import { MunicipioEntry } from "./../../../../../../../shared/entrys/municipio.entry";

import { CapacidadTecnicaService } from '../capacidad/capacidad-tecnica.service';
import { TipoCapacidad } from 'src/app/shared/enumeraciones/tipo-capacidad.enum';
import { elementAt } from 'rxjs/operators';
import { ModalValidarSubcategoriaComponent } from 'src/app/components/core/layouts/modal-validar-subcategoria/modal-validar-subcategoria.component';
import { ModalValidarCambiosActualizacionComponent } from 'src/app/components/core/layouts/modal-validar-cambios-actualizacion/modal-validar-cambios-actualizacion.component';
import { IndicesPasosPlataformasDigitales } from 'src/app/shared/enumeraciones/indices-pasos-plataformas-digitales.enum';
import { EstadosRnt } from 'src/app/shared/enumeraciones/estados-rnt.enum';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-tipo-establecimiento',
  templateUrl: './tipo-establecimiento.component.html',
  styleUrls: ['./tipo-establecimiento.component.scss']
})
export class TipoEstablecimientoComponent implements OnInit, OnDestroy {
  @Output()
  pasoActual: EventEmitter<number> = new EventEmitter();

  public auxCategoria: string;
  public isCategoria: boolean;

  camposAdicionales: Array<CampoAdicionalEntry>;
  listaTurismoAventura: Array<TurismoAventuraEntry>;
  documentos: Array<DocumentoModel>;
  formTipoEstablecimiento: FormGroup;
  rnt: RNTPrestadorEntry;
  datoSolicitudSharedModel: DatoSolicitudSharedModel;
  ratificaInformacion: RatificaInformacionEntry;
  campos_es_turismo_aventura: CampoAdicionalEntry;
  campos_aplica_propiedad_horizontal: CampoAdicionalEntry;
  campos_tieneautoriza_propiedad_horizontal: CampoAdicionalEntry;
  campos_vehiculo: CampoAdicionalEntry;
  es_turismo = false;
  tipos_identificaciones: Array<TipoIdentificacionEntry>;
  departamentos: Array<DepartamentoEntry>;
  municipios: Array<MunicipioEntry>;
  municipiosIzquierdo: Array<MunicipioEntry>;
  municipiosMultipleIzquierdo: Array<MunicipioEntry>;
  mostrarCapacidadTecnica: boolean = false;
  mostrarCapacidadOperativa: boolean = false;
  establecimientoDetalle: any;
  // CAMPO ADICIONAL
  // MULTIPLE
  multipleItem: Array<any> = [];
  //MULTIPLE CARACTERISTICAS
  multipleFeatureArrayMultiple: Array<any> = [];
  multipleFeatureCountMultiple: number = 0;
  multipleFeatureIndexArrayMultiple: Array<any> = [];
  //MULTIPLE CARACTERISTICAS

  // VARIOS REGISTROS
  registerCountMultiple: number = 0;
  registerResultMultiple: string = '';
  registerDataMultiple: Array<any> = [];
  registerJsonMultiple: any = {};
  registerArrayMultiple: Array<any> = [];
  registerArrayCountMultiple: number = 0;
  registerIndexArrayMultiple: Array<any> = [];
  // VARIOS REGISTROS
  // MULTIPLE

  // VARIOS REGISTROS
  registerCount: number = 0;
  registerResult: string = '';
  registerData: Array<any> = [];
  registerJson: any = {};
  registerArray: Array<any> = [];
  registerArrayCount: number = 0;
  registerIndexArray: Array<any> = [];
  // VARIOS REGISTROS

  //MULTIPLE CARACTERISTICAS
  multipleFeatureArray: Array<any> = [];
  multipleFeatureCount: number = 0;
  multipleFeatureIndexArray: Array<any> = [];
  //MULTIPLE CARACTERISTICAS
  // CAMPO ADICIONAL

  // DOCUMENTOS
  // MULTIPLE
  multipleItemDocumento: Array<any> = [];
  //MULTIPLE CARACTERISTICAS
  multipleFeatureArrayDocumentoMultiple: Array<any> = [];
  multipleFeatureCountDocumentoMultiple: number = 0;
  multipleFeatureIndexArrayDocumentoMultiple: Array<any> = [];
  //MULTIPLE CARACTERISTICAS
  // VARIOS REGISTROS
  registerCountDocumentoMultiple: number = 0;
  registerResultDocumentoMultiple: string = '';
  registerDataDocumentoMultiple: Array<any> = [];
  registerJsonDocumentoMultiple: any = {};
  registerArrayDocumentoMultiple: Array<any> = [];
  registerArrayCountDocumentoMultiple: number = 0;
  registerIndexArrayDocumentoMultiple: Array<any> = [];
  // VARIOS REGISTROS
  // MULTIPLE

  // VARIOS REGISTROS
  registerCountDocumento: number = 0;
  registerResultDocumento: string = '';
  registerDataDocumento: Array<any> = [];
  registerJsonDocumento: any = {};
  registerArrayDocumento: Array<any> = [];
  registerArrayCountDocumento: number = 0;
  registerIndexArrayDocumento: Array<any> = [];
  // VARIOS REGISTROS

  //MULTIPLE CARACTERISTICAS
  multipleFeatureArrayDocumento: Array<any> = [];
  multipleFeatureCountDocumento: number = 0;
  multipleFeatureIndexArrayDocumento: Array<any> = [];
  //MULTIPLE CARACTERISTICAS
  // DOCUMENTOS

  // V2
  listadoPreguntas: Array<any> = [];
  listadoPreguntasCampoAdicional: Array<any> = [];
  containerPreguntasDoc: any;
  containerPreguntasCampoAdicional: any;
  idDocPadreMultCarac: number = 0;
  disableBtnCampoAdicional: boolean = true;

  private _formValuesSubscriptions: Subscription[] = [];

  constructor(
    private alertService: AlertsService,
    private basicasLoVService: BasicasLoVService,
    private capacidadTecnicaService: CapacidadTecnicaService,
    private router: Router, private dataSharedService: DataSharedService,
    private tipoEstablecimientoService: TipoEstablecimientoService,
    private formBuilder: FormBuilder,
    private completaInformacionService: CompletaInformacionService, private authService: AuthService, private modalService: NgbModal,
    public ayudaService: AyudasService, private alertsService: AlertsService,
    protected sanitizer: DomSanitizer) {
    this.formTipoEstablecimiento = this.formBuilder.group({});
    this.listaTurismoAventura = [];
    this.documentos = [];
    this.campos_es_turismo_aventura = {} as CampoAdicionalEntry;
    this.campos_aplica_propiedad_horizontal = {} as CampoAdicionalEntry;
    this.campos_tieneautoriza_propiedad_horizontal = {} as CampoAdicionalEntry;
    this.campos_vehiculo = {} as CampoAdicionalEntry;
    this.dataSharedService.data$.subscribe(dataShared => {
      this.datoSolicitudSharedModel = dataShared as DatoSolicitudSharedModel;
      this.rnt = this.datoSolicitudSharedModel.data as RNTPrestadorEntry;
      this.completaInformacionService
        .getEstablecimientosPendiente(this.rnt)
        .subscribe((resultado) => {
          if (resultado.result) {
            this.establecimientoDetalle = resultado.data as EstablecimientoEntry;
            //this.deshabilitaSubcategoria();
          }
        });
      this.ratificaInformacion = this.datoSolicitudSharedModel.data.ratificaInformacion as RatificaInformacionEntry;
    });
  }

  ngOnInit() {
    this.formTipoEstablecimiento = this.formBuilder.group({});

    // NUEVA PARTE V2
    this.containerPreguntasDoc = document.getElementById('containerPreguntasDocumento');
    this.containerPreguntasCampoAdicional = document.getElementById('containerPreguntasCampoAdicional');
    this.rnt.es_comerciante = this.datoSolicitudSharedModel.data.tipo_rnt_id === TipoPrestadorId.Comerciante ? true : false;
    let idCategoria = this.datoSolicitudSharedModel.data.categoria_id;

    if (idCategoria == undefined) {
      idCategoria = 0
    }

    this.getConfiguracionCapacidadTecnica(idCategoria);
    this.getConfiguracionCapacidadOperativa(idCategoria);

    this.basicasLoVService.getTiposIdentificacion(null).subscribe(resultado => {
      if (resultado.result) {
        this.tipos_identificaciones = resultado.data as Array<TipoIdentificacionEntry>;
      }
    });

    this.basicasLoVService.getDepartamentos(null).subscribe(resultado => {
      if (resultado.result) {
        this.departamentos = resultado.data as Array<DepartamentoEntry>;
      }
    });

    this.preguntasDocumentosCampoAdicional();
    this.preguntasDocumentos();
    // FIN NUEVA PARTE

    this.validarCondicionCategoria();

    if (
      this.authService.getRolDetalleUser() !== TipoPrestador.Guia ||
      this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Inmuebles
    ) {
      this.pasoActual.emit(3);
      // if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Guia) {
      // 	this.pasoActual.emit(2);
      // } else {
      // 	this.pasoActual.emit(3);
      // }
    } else {
      this.pasoActual.emit(3);
      // if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.PlataformaDigitales) {
      // 	this.pasoActual.emit(3);
      // } else {
      // 	this.pasoActual.emit(2);
      // }
    }

    if (this.datoSolicitudSharedModel.data.estado_rnt_id ===
      EstadosRnt.SuspendidoPorNoRenovar &&
      this.datoSolicitudSharedModel.tipo_solicitud ===
      TipoSolicitud.Reactivacion) {
      this.pasoActual.emit(4);
    }

    /*this.tipoEstablecimientoService.get(this.rnt).subscribe((resultado) => {
      if (resultado.result) {
        this.documentos = resultado.data as Array<DocumentoModel>;

        this.createVariosRegistrosDataDocumento();
        this.createMultipleFeatureDataDocumento();
        if (this.documentos) {
          let formDocumento = null;
          this.documentos.forEach((element) => {
            this.contruirCampoDocumento(element);
            if (element.tipo_turismo_aventura_id) {
              if (element.requiere_numero_certificado) {
                formDocumento = new FormGroup({
                  [`chk-${element.tipo_turismo_aventura_id}`]: new FormControl(
                    element.activo,
                    element.es_obligatorio ? Validators.requiredTrue : null
                  ),
                  [`input-${element.tipo_turismo_aventura_id}`]:
                    new FormControl(
                      element.activo
                        ? element.numero_certificado
                        : { value: "", disabled: true },
                      element.es_obligatorio ? Validators.required : null
                    ),
                });
              } else {
                formDocumento = new FormControl(
                  element.activo,
                  element.es_obligatorio ? Validators.requiredTrue : null
                );
              }
            } else {
              if (element.requiere_numero_certificado) {
                formDocumento = new FormGroup({
                  [`chk-${element.documento_id}`]: new FormControl(
                    element.activo,
                    element.es_obligatorio ? Validators.requiredTrue : null
                  ),
                  [`input-${element.documento_id}`]: new FormControl(
                    element.activo
                      ? element.numero_certificado
                      : { value: "", disabled: true },
                    element.es_obligatorio ? Validators.required : null
                  ),
                });
              } else {
                formDocumento = new FormControl(
                  element.activo,
                  element.es_obligatorio ? Validators.requiredTrue : null
                );
              }
            }
          });
        }
      }
    });*/

    this.tipoEstablecimientoService.getCamposAdicionales(this.rnt).subscribe(resultado => {
      if (resultado.result) {
        this.camposAdicionales = resultado.data as Array<CampoAdicionalEntry>;
        if (this.camposAdicionales) {
          this.camposAdicionales.forEach(element => {

            this.construirCampo(element);
            if (element.campo_adicional_id === CamposAdicionalesEnum.EsTurismoAventura) {
              this.es_turismo = true;
              this.campos_es_turismo_aventura = element;
              this.formTipoEstablecimiento
                .get(element.desc_campo_adicional).setValidators(element.es_obligatorio ? Validators.required : null);
              if (element.valor === '1') {
                this.onCheckTurismo();
              }
            } else if (element.campo_adicional_id === CamposAdicionalesEnum.AplicaPropiedadHorizontal) {
              this.campos_aplica_propiedad_horizontal = element;
            } else if (element.campo_adicional_id === CamposAdicionalesEnum.TieneAutorizacionPropiedadHorizontal) {
              this.campos_tieneautoriza_propiedad_horizontal = element;
              // Agregamos validacion para verificar que las preguntas de propiedad horizontal sean coherentes
              const campo_aplica_propiedad_horizontal_desc = this.campos_aplica_propiedad_horizontal.desc_campo_adicional;
              let matchingControl = this.formTipoEstablecimiento.get(campo_aplica_propiedad_horizontal_desc);
              if (matchingControl) {
                let control = this.formTipoEstablecimiento.get(element.desc_campo_adicional);
                control.setValidators(ConfirmeValidators.mustMatchFieldValidator(campo_aplica_propiedad_horizontal_desc));
                // Observamos cambios en la pregunta anterior para realizar la validacion nuevamente
                let subscription = matchingControl.valueChanges.subscribe(_ => {
                  control.updateValueAndValidity();
                });
                this._formValuesSubscriptions.push(subscription);
              }
            } else if (element.campo_adicional_id === CamposAdicionalesEnum.RelacionarVehiculos) {
              this.campos_vehiculo = element;
              this.cargarFormCampoVehiculos();
            }

            this.formTipoEstablecimiento.updateValueAndValidity();
          });
        }
      }
    });
  }

  ngOnDestroy(): void {
    this._formValuesSubscriptions.forEach(subscripton => {
      subscripton.unsubscribe();
    })
  }

  cargarFormCampoVehiculos(): void {
    if (this.campos_vehiculo) {
      this.tipoEstablecimientoService.getVehiculos(1, {
        codigo_camara: this.rnt.codigo_camara,
        detalle_solicitud_id: this.rnt.detalle_solicitud_id
      }).subscribe(res => {
        if (res.result) {
          this.formTipoEstablecimiento.get(this.campos_vehiculo.desc_campo_adicional)
            .setValue((res.data as DatoPaginadoModel).paging.totalItems > 0);
        }
      });
    }
  }

  construirCampo(campo: CampoAdicionalEntry) {
    switch (campo.desc_tipo_dato) {
      case TipoCampoAdicional.Booleano:
        // tslint:disable-next-line:max-line-length
        this.formTipoEstablecimiento.addControl(campo.desc_campo_adicional, new FormControl(campo.valor === '1', campo.es_obligatorio ? Validators.requiredTrue : null));
        break;
      case TipoCampoAdicional.Texto:
        this.formTipoEstablecimiento.addControl(campo.desc_campo_adicional, new FormControl(campo.valor, campo.es_obligatorio ? Validators.required : null));
        break;
      case TipoCampoAdicional.Numerico:
        this.formTipoEstablecimiento.addControl(campo.desc_campo_adicional, new FormControl(campo.valor));
        if (campo.es_obligatorio) {
          // tslint:disable-next-line:max-line-length
          this.formTipoEstablecimiento.get(campo.desc_campo_adicional).setValidators([Validators.required, ConfirmeValidators.numberValidator, Validators.max(9999999999)]);
        } else {
          // tslint:disable-next-line:max-line-length
          this.formTipoEstablecimiento.get(campo.desc_campo_adicional).setValidators([ConfirmeValidators.numberValidator, Validators.max(9999999999)]);
        }
        break;
      case TipoCampoAdicional.Fecha:
        // tslint:disable-next-line:max-line-length
        this.formTipoEstablecimiento.addControl(campo.desc_campo_adicional, new FormControl(campo.valor ? new Date(campo.valor) : null, campo.es_obligatorio ? Validators.required : null));
        break;
      case TipoCampoAdicional.TextArea:
        this.formTipoEstablecimiento.addControl(campo.desc_campo_adicional, new FormControl(campo.valor, campo.es_obligatorio ? Validators.required : null));
        break;

      case TipoCampoAdicional.Multiple:
        this.formTipoEstablecimiento.addControl(campo.desc_campo_adicional, new FormControl(campo.valor, campo.es_obligatorio ? Validators.required : null));
        break;
      case TipoCampoAdicional.VariosRegistros:
        this.formTipoEstablecimiento.addControl(campo.desc_campo_adicional, new FormControl(campo.valor_varios_registros, (campo.valor_varios_registros && campo.es_obligatorio) ? Validators.required : null));
        break;

      case TipoCampoAdicional.MultipleCaracteristica:
        this.formTipoEstablecimiento.addControl(campo.desc_campo_adicional, new FormControl(campo.valor, campo.es_obligatorio ? Validators.required : null));
        break;
    }

    this.formTipoEstablecimiento.updateValueAndValidity();
  }

  // DOCUMENTO

  goPaso() {
    this.rnt.paso = 3;
    if (this.datoSolicitudSharedModel.data.estado_rnt_id ===
      EstadosRnt.SuspendidoPorNoRenovar &&
      this.datoSolicitudSharedModel.tipo_solicitud ===
      TipoSolicitud.Reactivacion) {
      this.rnt.paso = 4;
    }
    let turismoConcatenado = '';
    this.listaTurismoAventura.forEach(resultado => {
      if (resultado.seleccionado) {
        if (!turismoConcatenado) {
          turismoConcatenado = '';
        }
        turismoConcatenado += `${resultado.tipo_turismo_aventura_id},`;
      }
    });
    if ((this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion ||
      (this.datoSolicitudSharedModel.data.estado_rnt_id ===
        EstadosRnt.SuspendidoPorNoRenovar &&
        this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Reactivacion))) {
      if (!this.ratificaInformacion.cantidad_modificaciones || this.ratificaInformacion.cantidad_modificaciones < 1) {
        const confirmarRespuesta = {} as ConfirmarRespuestaModel;
        confirmarRespuesta.tipoConfirmacionModalType = TipoConfirmacionModalType.Confirmacion;
        confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
        confirmarRespuesta.message = 'No se registraron cambios. ¿Ratifica que la información registrada no ha sufrido cambios?';
        const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
        modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
        modalRef.result.then(confirmacion => {
          this.ratificaInformacion.ratifica_informacion = true;
          this.preGoPaso(turismoConcatenado);
        });
      } else {
        this.ratificaInformacion = {} as RatificaInformacionEntry;
        this.preGoPaso(turismoConcatenado);
      }
    } else {
      this.preGoPaso(turismoConcatenado);
    }
  }

  preGoPaso(turismoConcatenado: string) {
    if (this.es_turismo
      && this.formTipoEstablecimiento.get(this.campos_es_turismo_aventura.desc_campo_adicional).value
      && (!turismoConcatenado || turismoConcatenado.length < 0)) {
      this.alertsService.warn('Requiere seleccionar como minimo una categoria de tipo aventura', 'ninguna', '0');
      return;
    }
    if (this.es_turismo
      && this.campos_es_turismo_aventura
      && this.formTipoEstablecimiento.get(this.campos_es_turismo_aventura.desc_campo_adicional)
      && this.formTipoEstablecimiento.value[this.campos_es_turismo_aventura.desc_campo_adicional]) {
      this.tipoEstablecimientoService.asociarListatipoTurismo({ ...this.rnt, lista_tipos_turismo_aventura: turismoConcatenado })
        .subscribe(resultadoAsociar => {
          if (resultadoAsociar.result) {
            this.completaInformacionService.update({
              ...this.rnt, ...this.formTipoEstablecimiento.value,
              ...this.ratificaInformacion
            }).subscribe(resultado => {
              if (resultado.result) {
                this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
                  data: { ...this.rnt, ...this.formTipoEstablecimiento.value, ...this.ratificaInformacion } as RNTPrestadorEntry,
                  tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
                  tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
                  estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud
                });
                if (this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Actualizacion) {
                  this.checkUpdateChanges();
                } else {
                  this.router.navigate(['/solicitud/codigo-conducta']);
                }
              }
            });
          }
        });
    } else {
      this.completaInformacionService.update({
        ...this.rnt, ...this.formTipoEstablecimiento.value,
        ...this.ratificaInformacion
      }).subscribe(resultado => {
        if (resultado.result) {
          this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
            data: { ...this.rnt, ...this.formTipoEstablecimiento.value, ...this.ratificaInformacion } as RNTPrestadorEntry,
            tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
            tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
            estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud
          });
          if (this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Actualizacion) {
            this.checkUpdateChanges();
          } else {
            this.router.navigate(['/solicitud/codigo-conducta']);
          }

        }
      });
    }
  }

  onCheckDocumento(checkDocumento: DocumentoModel) {
    checkDocumento.activo = !checkDocumento.activo;
    this.tipoEstablecimientoService.update(checkDocumento).subscribe(resultado => {
      if (resultado.result) {
        if ((this.datoSolicitudSharedModel.data.estado_rnt_id ===
          EstadosRnt.SuspendidoPorNoRenovar &&
          this.datoSolicitudSharedModel.tipo_solicitud ===
          TipoSolicitud.Reactivacion)
          || (this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion)
          || (this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Actualizacion)) {
          this.ratificaInformacion.cantidad_modificaciones += 1;
          this.completaInformacionService.confirmarCambio({ ...this.rnt, ...this.ratificaInformacion }).subscribe();
        }
        // this.camposAdicionales = resultado.data as Array<CampoAdicionalEntry>;
      }
    });
  }

  onIngresarDocumentoCertificado(checkDocumento: DocumentoModel) {
    if (checkDocumento.tipo_turismo_aventura_id) {
      // tslint:disable-next-line:max-line-length
      const formCertifica = this.formTipoEstablecimiento.get(`formDocumento-T${checkDocumento.tipo_turismo_aventura_id}`);
      if (formCertifica.valid) {
        checkDocumento.activo = formCertifica.valid;
        this.tipoEstablecimientoService.update({
          ...checkDocumento,
          numero_certificado: formCertifica.get(`input-${checkDocumento.tipo_turismo_aventura_id}`).value
        } as DocumentoEntry).subscribe(resultado => {
          if (resultado.result) {
            if ((this.datoSolicitudSharedModel.data.estado_rnt_id ===
              EstadosRnt.SuspendidoPorNoRenovar &&
              this.datoSolicitudSharedModel.tipo_solicitud ===
              TipoSolicitud.Reactivacion)
              || (this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion)
              || (this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Actualizacion)) {
              this.ratificaInformacion.cantidad_modificaciones += 1;
              this.completaInformacionService.confirmarCambio({ ...this.rnt, ...this.ratificaInformacion }).subscribe();
            }
          }
        });
      }
    } else {
      // tslint:disable-next-line:max-line-length
      const formCertifica = this.formTipoEstablecimiento.get(`formDocumento-${checkDocumento.documento_id}`);
      if (formCertifica.valid) {
        checkDocumento.activo = formCertifica.valid;
        this.tipoEstablecimientoService.update({
          ...checkDocumento,
          numero_certificado: formCertifica.get(`input-${checkDocumento.documento_id}`).value
        } as DocumentoEntry).subscribe(resultado => {
          if (resultado.result) {
            if ((this.datoSolicitudSharedModel.data.estado_rnt_id ===
              EstadosRnt.SuspendidoPorNoRenovar &&
              this.datoSolicitudSharedModel.tipo_solicitud ===
              TipoSolicitud.Reactivacion)
              || (this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion)
              || (this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Actualizacion)) {
              this.ratificaInformacion.cantidad_modificaciones += 1;
              this.completaInformacionService.confirmarCambio({ ...this.rnt, ...this.ratificaInformacion }).subscribe();
            }
          }
        });
      }
    }
  }
  checkUpdateChanges(): void {
    if (this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Actualizacion) {
      this.tipoEstablecimientoService
        .checkUpdateChanges(this.rnt)
        .subscribe(response => {
          if (!response.data) {
            this.completaInformacionService
              .getParametro({
                parametro_id: "ADVERTENCIA_NO_CAMBIOS_ACTUALIZACION",
                agrupacion: "VALIDACIONES",
                auxiliar: "1",
              }).subscribe((resultado2) => {
                if (resultado2.result) {
                  const modalAceptarTerminos = this.modalService.open(
                    ModalValidarCambiosActualizacionComponent,
                    { centered: true, backdrop: "static", size: "md" }
                  );
                  modalAceptarTerminos.componentInstance.mensaje = resultado2.data;
                }
              });
          } else {
            this.router.navigate(['/solicitud/codigo-conducta']);
          }
        })
    } else {
      this.router.navigate(['/solicitud/codigo-conducta']);
    }
  }
  onCheckDocumentoCertificado(checkDocumento: DocumentoModel) {
    if (checkDocumento.tipo_turismo_aventura_id) {
      // tslint:disable-next-line:max-line-length
      const formCertifica = this.formTipoEstablecimiento.get(`formDocumento-T${checkDocumento.tipo_turismo_aventura_id}`);
      if (!formCertifica.get(`chk-${checkDocumento.tipo_turismo_aventura_id}`).value) {
        formCertifica.get(`input-${checkDocumento.tipo_turismo_aventura_id}`).setValue('');
        formCertifica.get(`input-${checkDocumento.tipo_turismo_aventura_id}`).enable();
      } else {
        formCertifica.get(`input-${checkDocumento.tipo_turismo_aventura_id}`).setValue('');
        formCertifica.get(`input-${checkDocumento.tipo_turismo_aventura_id}`).disable();
      }
    } else {
      // tslint:disable-next-line:max-line-length
      const formCertifica = this.formTipoEstablecimiento.get(`formDocumento-${checkDocumento.documento_id}`);
      if (!formCertifica.get(`chk-${checkDocumento.documento_id}`).value) {
        formCertifica.get(`input-${checkDocumento.documento_id}`).setValue('');
        formCertifica.get(`input-${checkDocumento.documento_id}`).enable();
      } else {
        formCertifica.get(`input-${checkDocumento.documento_id}`).setValue('');
        formCertifica.get(`input-${checkDocumento.documento_id}`).disable();
      }
    }
  }

  onCheckTurismo() {
    if (this.formTipoEstablecimiento.value[this.campos_es_turismo_aventura.desc_campo_adicional]) {
      this.onCampoAdicionalCheck(this.campos_es_turismo_aventura.desc_campo_adicional);
      this.tipoEstablecimientoService.getListaCheckTurismo(this.rnt).subscribe(resultado => {
        if (resultado.result) {
          if ((this.datoSolicitudSharedModel.data.estado_rnt_id ===
            EstadosRnt.SuspendidoPorNoRenovar &&
            this.datoSolicitudSharedModel.tipo_solicitud ===
            TipoSolicitud.Reactivacion)
            || (this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion)
            || (this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Actualizacion)) {
            this.ratificaInformacion.cantidad_modificaciones += 1;
            this.completaInformacionService.confirmarCambio({ ...this.rnt, ...this.ratificaInformacion }).subscribe();
          }
          this.listaTurismoAventura = resultado.data as Array<TurismoAventuraEntry>;
        }
      });
    } else {
      this.onCampoAdicionalCheck(this.campos_es_turismo_aventura.desc_campo_adicional);
      if ((this.datoSolicitudSharedModel.data.estado_rnt_id ===
        EstadosRnt.SuspendidoPorNoRenovar &&
        this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Reactivacion)
        || (this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion)
        || (this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Actualizacion)) {
        this.ratificaInformacion.cantidad_modificaciones += 1;
        this.completaInformacionService.confirmarCambio({ ...this.rnt, ...this.ratificaInformacion }).subscribe();
      }
      this.listaTurismoAventura.map(resultado => {
        if (resultado.seleccionado) {
          let documentos = [];
          documentos = this.documentos.filter(datoSel => {
            return (datoSel.tipo_turismo_aventura_id === resultado.tipo_turismo_aventura_id);
          });
          documentos.forEach(buscar => {
            this.documentos.splice(this.documentos.indexOf(buscar), 1);
          });
          this.formTipoEstablecimiento.removeControl(`formDocumento-T${resultado.tipo_turismo_aventura_id}`);
        }
      });
      this.tipoEstablecimientoService.asociarListatipoTurismo({ ...this.rnt, lista_tipos_turismo_aventura: '' })
        .subscribe();
      this.tipoEstablecimientoService.desasociarListatipoTurismo(this.rnt)
        .subscribe();
      this.listaTurismoAventura = [];
    }
  }

  onLinkDocumento(evento, turismoAventuraEntry: TurismoAventuraEntry) {
    if (this.formTipoEstablecimiento.value[this.campos_es_turismo_aventura.desc_campo_adicional]
      // tslint:disable-next-line:max-line-length
      && evento.target.checked) {
      turismoAventuraEntry.activo = true;
      this.tipoEstablecimientoService.getDocumentoTurismo({ ...this.rnt, ...turismoAventuraEntry }).subscribe(resultado => {
        if (resultado.result) {
          if ((this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion)
            || (this.datoSolicitudSharedModel.data.estado_rnt_id ===
              EstadosRnt.SuspendidoPorNoRenovar &&
              this.datoSolicitudSharedModel.tipo_solicitud ===
              TipoSolicitud.Reactivacion)
            || (this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Actualizacion)) {
            this.ratificaInformacion.cantidad_modificaciones += 1;
            this.completaInformacionService.confirmarCambio({ ...this.rnt, ...this.ratificaInformacion }).subscribe();
          }
          let formDocumento = null;
          // tslint:disable-next-line:max-line-length
          this.listaTurismoAventura.find(buscar => buscar.tipo_turismo_aventura_id === turismoAventuraEntry.tipo_turismo_aventura_id).seleccionado = true;
          if (resultado.data && resultado.data.length > 0) {
            resultado.data.forEach(documento => {
              if (documento.requiere_numero_certificado) {
                formDocumento = new FormGroup({
                  [`chk-${turismoAventuraEntry.tipo_turismo_aventura_id}`]: new FormControl(documento.activo, documento.es_obligatorio ?
                    Validators.requiredTrue : null),
                  [`input-${turismoAventuraEntry.tipo_turismo_aventura_id}`]: new FormControl(documento.activo ?
                    documento.numero_certificado : { value: '', disabled: true }, documento.es_obligatorio ? Validators.required : null)
                });
              } else {
                formDocumento = new FormControl(documento.activo, documento.es_obligatorio ? Validators.requiredTrue : null);
              }
              this.formTipoEstablecimiento.addControl(`formDocumento-T${turismoAventuraEntry.tipo_turismo_aventura_id}`, formDocumento);
              if (!this.documentos) {
                this.documentos = [];
              }
              this.documentos.push({ ...documento, tipo_turismo_aventura_id: turismoAventuraEntry.tipo_turismo_aventura_id });
            });
          }
        }
      });
    } else {
      turismoAventuraEntry.activo = false;
      turismoAventuraEntry.seleccionado = false;
      this.tipoEstablecimientoService.getDesasociarDocumentoTurismo({ ...this.rnt, ...turismoAventuraEntry }).subscribe(resultado => {
        if (resultado.result) {
          if ((this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion)
            || (this.datoSolicitudSharedModel.data.estado_rnt_id ===
              EstadosRnt.SuspendidoPorNoRenovar &&
              this.datoSolicitudSharedModel.tipo_solicitud ===
              TipoSolicitud.Reactivacion)
            || (this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Actualizacion)) {
            this.ratificaInformacion.cantidad_modificaciones += 1;
            this.completaInformacionService.confirmarCambio({ ...this.rnt, ...this.ratificaInformacion }).subscribe();
          }
          let documentos = [];
          documentos = this.documentos.filter(datoSel => {
            return (datoSel.tipo_turismo_aventura_id === turismoAventuraEntry.tipo_turismo_aventura_id);
          });
          documentos.forEach(buscar => {
            this.documentos.splice(this.documentos.indexOf(buscar), 1);
          });
          this.formTipoEstablecimiento.removeControl(`formDocumento-T${turismoAventuraEntry.tipo_turismo_aventura_id}`);
          // tslint:disable-next-line:max-line-length
          this.listaTurismoAventura.find(buscar => buscar.tipo_turismo_aventura_id === turismoAventuraEntry.tipo_turismo_aventura_id).seleccionado = false;
        }
      });
    }
  }

  onCampoAdicionalCheck(desc_campo_adicional: string) {
    const campo = this.camposAdicionales.find(elemento => elemento.desc_campo_adicional === desc_campo_adicional);
    const campoControl = this.formTipoEstablecimiento.get(desc_campo_adicional);

    if (campoControl.valid) {
      campo.valor = campoControl.value ? '1' : '0';
      campo.opciones = null;
      // tslint:disable-next-line:max-line-length
      this.tipoEstablecimientoService.updateCampoAdicional(campo).subscribe(resultado => {
        if (resultado.result) {
          if ((this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion)
            || (this.datoSolicitudSharedModel.data.estado_rnt_id ===
              EstadosRnt.SuspendidoPorNoRenovar &&
              this.datoSolicitudSharedModel.tipo_solicitud ===
              TipoSolicitud.Reactivacion)
            || (this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Actualizacion)) {
            this.ratificaInformacion.cantidad_modificaciones += 1;
            this.completaInformacionService.confirmarCambio({ ...this.rnt, ...this.ratificaInformacion }).subscribe();
          }
        }
      });
    } else {
      campo.valor = campoControl.value ? '1' : '0';
      // tslint:disable-next-line:max-line-length
      this.tipoEstablecimientoService.updateCampoAdicional(campo).subscribe(resultado => {
        if (resultado.result) {
          if ((this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion)
            || (this.datoSolicitudSharedModel.data.estado_rnt_id ===
              EstadosRnt.SuspendidoPorNoRenovar &&
              this.datoSolicitudSharedModel.tipo_solicitud ===
              TipoSolicitud.Reactivacion)
            || (this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Actualizacion)) {
            this.ratificaInformacion.cantidad_modificaciones += 1;
            this.completaInformacionService.confirmarCambio({ ...this.rnt, ...this.ratificaInformacion }).subscribe();
          }
        }
      });
    }
  }

  onRegresarPaso(): void {
    let backRoute: string;

    if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Guia) { // Guia
      if (this.mostrarCapacidadOperativa || this.mostrarCapacidadTecnica) {
        this.rnt.paso = 2;
        if ((this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion)) {
          this.rnt.paso = 3;
        }
        backRoute = '/solicitud/capacidad';
      } else {
        this.rnt.paso = 1;
        if ((this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion)) {
          this.rnt.paso = 2;
        }
        backRoute = '/solicitud/completa-informacion-guia';
      }
    } else { // Otros
      this.rnt.paso = 2;
      if (this.mostrarCapacidadOperativa || this.mostrarCapacidadTecnica) {
        this.rnt.paso = 2;
        if ((this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion)) {
          this.rnt.paso = 3;
        }
        backRoute = '/solicitud/capacidad';
      } else {
        this.rnt.paso = 1;
        if ((this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion)) {
          this.rnt.paso = 2;
        }
        switch (this.datoSolicitudSharedModel.tipo_rnt) {
          case TipoRnt.Establecimiento:
            backRoute = '/solicitud/completa-informacion';
            break;
          case TipoRnt.Inmuebles:
            backRoute = '/solicitud/completa-informacion-inmueble'
            break;
          case TipoRnt.PlataformaDigitales:
            backRoute = '/solicitud/completa-informacion-plataformas';
            break;
        }
      }
    }

    let turismoConcatenado = '';
    this.listaTurismoAventura.map(resultado => {
      if (resultado.seleccionado) {
        turismoConcatenado += `${resultado.tipo_turismo_aventura_id},`;
      }
    });

    if (turismoConcatenado.length > 0) {
      this.tipoEstablecimientoService.asociarListatipoTurismo({ ...this.rnt, lista_tipos_turismo_aventura: turismoConcatenado })
        .subscribe(resultadoAsociar => {
          if (resultadoAsociar.result) {
            this.completaInformacionService.update({
              ...this.rnt, ...this.formTipoEstablecimiento.value,
              ...this.ratificaInformacion
            }).subscribe(resultado => {
              if (resultado.result) {
                this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
                  data: { ...this.rnt, ...this.formTipoEstablecimiento.value, ...this.ratificaInformacion } as RNTPrestadorEntry,
                  tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
                  tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
                  estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud
                });
                this.router.navigate([backRoute]);
              }
            });
          }
        });
    } else {
      this.completaInformacionService.update({
        ...this.rnt, ...this.formTipoEstablecimiento.value,
        ...this.ratificaInformacion
      }).subscribe(resultado => {
        if (resultado.result) {
          this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
            data: { ...this.rnt, ...this.formTipoEstablecimiento.value, ...this.ratificaInformacion } as RNTPrestadorEntry,
            tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
            tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
            estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud
          });
          this.router.navigate([backRoute]);
        }
      });
    }
  }

  onCheckPropiedadHorizontal() {
    if (this.formTipoEstablecimiento.value[this.campos_aplica_propiedad_horizontal.desc_campo_adicional]) {
      this.onCampoAdicionalCheck(this.campos_aplica_propiedad_horizontal.desc_campo_adicional);
      this.formTipoEstablecimiento.get(this.campos_tieneautoriza_propiedad_horizontal.desc_campo_adicional).patchValue(false);
      this.onCampoAdicionalCheck(this.campos_tieneautoriza_propiedad_horizontal.desc_campo_adicional);
    } else {
      this.onCampoAdicionalCheck(this.campos_aplica_propiedad_horizontal.desc_campo_adicional);
      this.formTipoEstablecimiento.get(this.campos_tieneautoriza_propiedad_horizontal.desc_campo_adicional).patchValue(false);
      this.onCampoAdicionalCheck(this.campos_tieneautoriza_propiedad_horizontal.desc_campo_adicional);
    }
  }

  get TipoCampoAdicional() {
    return TipoCampoAdicional;
  }

  get CamposAdicionalesEnum() {
    return CamposAdicionalesEnum;
  }

  validarCampoAdicional(campoAdicional: CampoAdicionalEntry) {
    for (const campo in CamposAdicionalesEnum) {
      // tslint:disable-next-line:radix
      if (campoAdicional.campo_adicional_id === Number.parseInt(campo)) {
        return true;
      }
    }
    return false;
  }

  buscarCampoAdicional(campo: any): CampoAdicionalEntry {
    if (this.camposAdicionales) {
      // tslint:disable-next-line:radix
      return this.camposAdicionales.find(buscar => buscar.campo_adicional_id === campo);
    } else {
      return null;
    }
  }

  onOpenModalVehiculos() {
    this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
      data: { ...this.rnt, ...this.formTipoEstablecimiento.value, ...this.ratificaInformacion } as RNTPrestadorEntry,
      tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
      tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
      estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud
    });
    const modalRef = this.modalService.open(ModalArriendoVehiculoComponent,
      { centered: true, size: 'lg', backdropClass: 'light-blue-backdrop', windowClass: 'modal-customer-xl' });
    modalRef.result.then(resultado => {
      this.cargarFormCampoVehiculos();
    }).catch(resultado => {
      this.cargarFormCampoVehiculos();
    });
  }

  obtener_storage() {
    this.auxCategoria = localStorage.getItem("keyCategoria");
  }

  validarCondicionCategoria() {
    this.auxCategoria = localStorage.getItem('idCategoria');

    if (this.auxCategoria == "20" || this.auxCategoria == "21") {
      this.isCategoria = true;
    } else {
      this.isCategoria = false;
    }
  }

  getConfiguracionCapacidadTecnica(idCategoria) {
    let idCapacidadTecnica = TipoCapacidad.Tecnica;
    let isComerciante = this.authService.getRolDetalleUser() === TipoPrestador.Comerciante ? true : false;

    this.capacidadTecnicaService.getConfigCapacidades(idCapacidadTecnica, idCategoria)
      .subscribe((response) => {
        if (response.result) {
          if (response.data[0]) {
            if (isComerciante) {
              this.mostrarCapacidadTecnica = response.data[0].Se_Muestra_Comerciante;
            } else {
              this.mostrarCapacidadTecnica = response.data[0].Se_Muestra_No_Comerciante;
            }
          } else {
            console.log('___WARNING, NO DATA FOUND');
          }
        } else {
          console.log('___ERROR, WEB SERVICE');
        }
      });
  }

  getConfiguracionCapacidadOperativa(idCategoria) {
    let idCapacidadTecnica = TipoCapacidad.Operativa;
    let isComerciante = this.authService.getRolDetalleUser() === TipoPrestador.Comerciante ? true : false;

    this.capacidadTecnicaService.getConfigCapacidades(idCapacidadTecnica, idCategoria)
      .subscribe((response) => {
        if (response.result) {
          if (response.data[0]) {
            if (isComerciante) {
              this.mostrarCapacidadOperativa = response.data[0].Se_Muestra_Comerciante;
            } else {
              this.mostrarCapacidadOperativa = response.data[0].Se_Muestra_No_Comerciante;
            }
          } else {
            console.log('___WARNING, NO DATA FOUND');
          }
        } else {
          console.log('___ERROR, WEB SERVICE');
        }
      });
  }

  // ---------------------   V2   -----------------------

  // DOCUMENTOS IZQUIERDO
  preguntasDocumentosCampoAdicional() {
    this.tipoEstablecimientoService.getCamposAdicionales(this.rnt).subscribe((resultado) => {
      if (resultado.result) {
        this.listadoPreguntasCampoAdicional = resultado.data;
        const totalPreguntas = this.listadoPreguntasCampoAdicional.length;

        for (let i = 0; i < totalPreguntas; i++) {

          //Carga los datos que son diferentes a Aventura.
          if (!this.validarCampoAdicional(this.listadoPreguntasCampoAdicional[i])) {
            this.generarPreguntaDocumento(this.listadoPreguntasCampoAdicional[i], true);
            // Obtener el ID del documento Padre (Solo aplica para MULTIPLE)
            if (this.listadoPreguntasCampoAdicional[i].desc_tipo_dato === TipoCampoAdicional.Multiple) {
              if (this.idDocPadreMultCarac === 0) {
                this.idDocPadreMultCarac = this.listadoPreguntasCampoAdicional[i].documento_id;
              }
            }
          }
        }
        this.validarForm();
      } else {
        console.log('ERROR, verificar el servicio');
      }
    });
  }

  // DOCUMENTOS
  preguntasDocumentos() {
    this.tipoEstablecimientoService.get(this.rnt).subscribe((resultado) => {
      if (resultado.result) {
        this.listadoPreguntas = resultado.data;
        const totalPreguntas = this.listadoPreguntas.length;

        for (let i = 0; i < totalPreguntas; i++) {
          this.generarPreguntaDocumento(this.listadoPreguntas[i]);
          // Obtener el ID del documento Padre (Solo aplica para MULTIPLE)
          if (this.listadoPreguntas[i].desc_tipo_dato === TipoCampoAdicional.Multiple) {
            if (this.idDocPadreMultCarac === 0) {
              this.idDocPadreMultCarac = this.listadoPreguntas[i].documento_id;
            }
          }
        }
        this.validarForm();
      } else {
        console.log('ERROR, verificar el servicio');
      }
    });
  }

  generarPreguntaDocumento(pregunta, campoAdicional = false) {
    let contenedorPregunta = document.createElement('div');
    contenedorPregunta.setAttribute('id', 'div_pregunta_' + (campoAdicional ? 'campoAdicional_' + pregunta.campo_adicional_id : 'doc_' + pregunta.documento_id));
    contenedorPregunta.className = 'borderTemp w-100 mb-3 p-2';
    if (campoAdicional) {
      this.containerPreguntasCampoAdicional.append(contenedorPregunta);
    } else {
      this.containerPreguntasDoc.append(contenedorPregunta);
    }

    this.generarTipoPreguntaDocumento(pregunta, contenedorPregunta, campoAdicional);
  }

  arrayDocumentoVariosRegistros: Array<any> = [];
  generarTipoPreguntaDocumento(pregunta, contenedorPregunta, campoAdicional = false) {
    let required = pregunta.es_obligatorio ? 'required' : '';
    let isMultiple = false;

    if (pregunta.desc_tipo_dato === TipoCampoAdicional.Texto || pregunta.desc_tipo_dato === TipoCampoAdicional.Numerico) { // Pregunta tipo VARCHAR/BIGINT
      let descPregunta = document.createElement("label");
      descPregunta.textContent = campoAdicional ? pregunta.titulo : pregunta.desc_documento;
      descPregunta.className = required;
      contenedorPregunta.append(descPregunta);

      let input = document.createElement("input");
      if (pregunta.desc_tipo_dato === TipoCampoAdicional.Texto) {
        input.type = "text";
      } else {
        input.type = "number";
      }
      input.className = "form-control";
      input.id = 'input_' + (campoAdicional ? 'campoAdicional_' + pregunta.campo_adicional_id : 'doc_' + pregunta.documento_id);
      input.value = pregunta.valor;
      input.addEventListener('change', (event) => {
        let idDocumento: any;
        let valueSelected = (<HTMLInputElement>event.target).value;
        // Preguntas de tipo MULTIPLE (Hijas)
        if (isMultiple) {
          idDocumento = this.idDocPadreMultCarac;
          pregunta.valor = valueSelected;
        } else {
          idDocumento = campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id;
        }

        this.guardarCampoDocumento(idDocumento, false, pregunta, campoAdicional);
        this.validarForm();
      });
      contenedorPregunta.append(input);
      if (campoAdicional) {
        this.arrayIdInputAdicional.push({ required: required, idInput: 'input_campoAdicional_' + pregunta.campo_adicional_id, id: pregunta.campo_adicional_id, inputType: pregunta.desc_tipo_dato, idPrincipal: '', idHija: '', es_numero_positivo: pregunta.es_numero_positivo })
      } else {
        this.arrayIdInput.push({ required: required, idInput: 'input_doc_' + pregunta.documento_id, id: pregunta.documento_id, inputType: pregunta.desc_tipo_dato, idPrincipal: '', idHija: '' });
      }

    } else if (pregunta.desc_tipo_dato === TipoCampoAdicional.Booleano) { // Pregunta tipo BIT
      // Contenedor del div
      let contenedorDiv = document.createElement("div");
      contenedorDiv.className = 'd-flex';
      contenedorPregunta.append(contenedorDiv);

      //Contenedor Input
      let contenedorInput = document.createElement("div");
      contenedorDiv.append(contenedorInput);

      //Contenedor Label
      let contenedorLabel = document.createElement("div");
      contenedorDiv.append(contenedorLabel);

      let checkbox = document.createElement("input");
      checkbox.type = "checkbox";
      checkbox.className = "mr-1";
      checkbox.id = 'input_' + (campoAdicional ? 'campoAdicional_' + pregunta.campo_adicional_id : 'doc_' + pregunta.documento_id);
      checkbox.checked = pregunta.valor === '1' ? true : false;
      checkbox.addEventListener('change', (event) => {
        let idDocumento: any;
        let valueSelected = (<HTMLInputElement>event.target).value;
        // Preguntas de tipo MULTIPLE (Hijas)
        if (isMultiple) {
          idDocumento = this.idDocPadreMultCarac;
          pregunta.valor = valueSelected;
        } else {
          idDocumento = campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id;
        }

        this.guardarCampoDocumento(idDocumento, false, pregunta, campoAdicional)
        this.validarForm();
      });
      contenedorInput.append(checkbox);

      let descPregunta = document.createElement("label");
      descPregunta.textContent = campoAdicional ? pregunta.titulo : pregunta.desc_documento;
      descPregunta.className = required;
      contenedorLabel.append(descPregunta);
      if (campoAdicional) {
        this.arrayIdInputAdicional.push({ required: required, idInput: 'input_campoAdicional_' + pregunta.campo_adicional_id, id: pregunta.campo_adicional_id, inputType: pregunta.desc_tipo_dato, idPrincipal: '', idHija: '' })
      } else {
        this.arrayIdInput.push({ required: required, idInput: 'input_doc_' + pregunta.documento_id, id: pregunta.documento_id, inputType: pregunta.desc_tipo_dato, idPrincipal: '', idHija: '' });
      }

    } else if (pregunta.desc_tipo_dato === TipoCampoAdicional.TextArea) { // Pregunta tipo TEXTAREA
      let descPregunta = document.createElement("label");
      descPregunta.textContent = campoAdicional ? pregunta.titulo : pregunta.desc_documento;
      descPregunta.className = required;
      contenedorPregunta.append(descPregunta);

      let input = document.createElement("textarea");
      input.className = "form-control";
      input.id = 'input_' + (campoAdicional ? 'campoAdicional_' + pregunta.campo_adicional_id : 'doc_' + pregunta.documento_id);
      input.value = pregunta.valor;
      input.addEventListener('change', (event) => {
        let idDocumento: any;
        let valueSelected = (<HTMLInputElement>event.target).value;
        // Preguntas de tipo MULTIPLE (Hijas)
        if (isMultiple) {
          idDocumento = this.idDocPadreMultCarac;
          pregunta.valor = valueSelected;
        } else {
          idDocumento = campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id;
        }

        this.guardarCampoDocumento(idDocumento, false, pregunta, campoAdicional)
        this.validarForm();
      });
      contenedorPregunta.append(input);
      if (campoAdicional) {
        this.arrayIdInputAdicional.push({ required: required, idInput: 'input_campoAdicional_' + pregunta.campo_adicional_id, id: pregunta.campo_adicional_id, inputType: pregunta.desc_tipo_dato, idPrincipal: '', idHija: '' })
      } else {
        this.arrayIdInput.push({ required: required, idInput: 'input_doc_' + pregunta.documento_id, id: pregunta.documento_id, inputType: pregunta.desc_tipo_dato, idPrincipal: '', idHija: '' });
      }
    } else if (pregunta.desc_tipo_dato === TipoCampoAdicional.Fecha) { // Pregunta tipo DATETIME
      let descPregunta = document.createElement("label");
      descPregunta.textContent = campoAdicional ? pregunta.titulo : pregunta.desc_documento;
      descPregunta.className = required;
      contenedorPregunta.append(descPregunta);

      let input = document.createElement("input");
      input.className = "form-control form-control-sm";
      input.id = 'input_' + (campoAdicional ? 'campoAdicional_' + pregunta.campo_adicional_id : 'doc_' + pregunta.documento_id);
      input.value = pregunta.valor;
      input.placeholder = 'yyyy/mm/dd';
      input.type = "date";
      input.attributes
      input.addEventListener('change', (event) => {
        let idDocumento: any;
        let valueSelected = (<HTMLInputElement>event.target).value;
        // Preguntas de tipo MULTIPLE (Hijas)
        if (isMultiple) {
          idDocumento = this.idDocPadreMultCarac;
          pregunta.valor = valueSelected;
        } else {
          idDocumento = campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id;
        }

        this.guardarCampoDocumento(idDocumento, false, pregunta, campoAdicional);
        this.validarForm();
      });

      contenedorPregunta.append(input);
      if (campoAdicional) {
        this.arrayIdInputAdicional.push({ required: required, idInput: 'input_campoAdicional_' + pregunta.campo_adicional_id, id: pregunta.campo_adicional_id, inputType: pregunta.desc_tipo_dato, idPrincipal: '', idHija: '' })
      } else {
        this.arrayIdInput.push({ required: required, idInput: 'input_doc_' + pregunta.documento_id, id: pregunta.documento_id, inputType: pregunta.desc_tipo_dato, idPrincipal: '', idHija: '' });
      }

    } else if (pregunta.desc_tipo_dato === TipoCampoAdicional.MultipleCaracteristica) { // Pregunta tipo MULTIPLE CARACTERISTICA
      let tituloMultipleCarac = document.createElement("p");
      tituloMultipleCarac.textContent = campoAdicional ? pregunta.titulo : pregunta.desc_documento + ':';
      tituloMultipleCarac.className = required;
      contenedorPregunta.append(tituloMultipleCarac);

      // Contendor de las caracteristicas
      let contenedorCaracteristicas = document.createElement("div");
      contenedorCaracteristicas.className = "pl-3";
      contenedorPregunta.append(contenedorCaracteristicas);

      if (campoAdicional) {
        this.arrayIdInputAdicional.push({ required: required, idInput: 'input_campoAdicional_' + pregunta.campo_adicional_id, id: pregunta.campo_adicional_id, inputType: pregunta.desc_tipo_dato, idPrincipal: '', idHija: '' })
      } else {
        this.arrayIdInput.push({ required: required, idInput: 'input_doc_' + pregunta.documento_id, id: pregunta.documento_id, inputType: pregunta.desc_tipo_dato, idPrincipal: '', idHija: '' });
      }

      // Mostrar las caracterisitcas
      let opcCaracteristicas = pregunta.caracteristicas_Opciones;
      for (let i = 0; i < opcCaracteristicas.length; i++) {
        let tmp = opcCaracteristicas[i];
        let descPregunta = document.createElement("label");

        if (tmp.caracteristicas_opciones_descripcion === TipoCampoAdicional.Fecha || tmp.caracteristicas_opciones_descripcion === TipoCampoAdicional.Texto
          || tmp.caracteristicas_opciones_descripcion === TipoCampoAdicional.Numerico) {

          let input = document.createElement("input");
          input.className = "form-control";
          input.id = 'input_' + (campoAdicional ? 'campoAdicional_' + tmp.caracteristicas_campo_adicional_opciones_id : 'doc_' + tmp.caracteristicas_documento_opciones_id);
          input.setAttribute('data-idCaracteristicaDoc', (campoAdicional ? tmp.caracteristicas_campo_adicional_opciones_id : tmp.caracteristicas_documento_opciones_id));
          input.value = tmp.Valor_Registros;
          input.addEventListener('change', (event) => {
            let idDocumento: any;
            let valueSelected = (<HTMLInputElement>event.target).value;

            // Buscar la caracteristica que se modifico
            let itemModify;
            if (campoAdicional) {
              itemModify = (pregunta.caracteristicas_Opciones).find(element => element.caracteristicas_campo_adicional_opciones_id == tmp.caracteristicas_campo_adicional_opciones_id);
            } else {
              itemModify = (pregunta.caracteristicas_Opciones).find(element => element.caracteristicas_documento_opciones_id == tmp.caracteristicas_documento_opciones_id);
            }
            itemModify.Valor_Registros = valueSelected

            // Preguntas de tipo MULTIPLE (Hijas)
            if (isMultiple) {
              idDocumento = this.idDocPadreMultCarac;
              tmp.Valor_Registros = valueSelected;
            } else {
              idDocumento = (campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id);
            }

            this.guardarCampoDocumento((campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id), (campoAdicional ? tmp.caracteristicas_campo_adicional_opciones_id : tmp.caracteristicas_documento_opciones_id), pregunta, campoAdicional);
            this.validarForm();
          });

          descPregunta.textContent = tmp.descripcion;
          contenedorCaracteristicas.append(descPregunta);

          if (tmp.caracteristicas_opciones_descripcion === TipoCampoAdicional.Fecha) { // Date
            input.type = "date";
          } else if (tmp.caracteristicas_opciones_descripcion === TipoCampoAdicional.Texto || tmp.caracteristicas_opciones_descripcion === TipoCampoAdicional.Numerico) { // Alfanumerico, Numerico
            if (tmp.caracteristicas_opciones_descripcion === TipoCampoAdicional.Texto) {
              input.type = "text";
            } else {
              input.type = "number";
            }
          }

          contenedorCaracteristicas.append(input);
          if (campoAdicional) {
            this.arrayIdInputAdicional.push({
              required: required, idInput: 'input_campoAdicional_' + tmp.caracteristicas_campo_adicional_opciones_id, id: tmp.caracteristicas_campo_adicional_opciones_id,
              inputType: tmp.caracteristicas_opciones_descripcion, idPrincipal: pregunta.campo_adicional_id, idHija: ''
            })
          } else {
            this.arrayIdInput.push({
              required: required, idInput: 'input_doc_' + tmp.caracteristicas_documento_opciones_id,
              id: tmp.caracteristicas_documento_opciones_id, inputType: tmp.caracteristicas_opciones_descripcion, idPrincipal: pregunta.documento_id, idHija: ''
            });
          }

        } else if (tmp.caracteristicas_opciones_descripcion === TipoCampoAdicional.TipoDocumento) {
          if (this.tipos_identificaciones == null || this.tipos_identificaciones == undefined) {
            this.basicasLoVService.getTiposIdentificacion(null).subscribe(resultado => {
              if (resultado.result) {
                this.tipos_identificaciones = resultado.data as Array<TipoIdentificacionEntry>;
                this.controlSeleccionarTipoDocumento(descPregunta, pregunta, tmp, contenedorCaracteristicas, required, campoAdicional);
              }
            });
          } else {
            this.controlSeleccionarTipoDocumento(descPregunta, pregunta, tmp, contenedorCaracteristicas, required, campoAdicional);
          }
        } else if (tmp.caracteristicas_opciones_descripcion === TipoCampoAdicional.Municipio) {
          if (this.departamentos == null || this.departamentos == undefined) {
            this.basicasLoVService.getDepartamentos(null).subscribe(resultado => {
              if (resultado.result) {
                this.departamentos = resultado.data as Array<DepartamentoEntry>;
                this.controlSeleccionarDepartamento(descPregunta, pregunta, tmp, contenedorCaracteristicas, required, campoAdicional);
              }
            });
          } else {
            this.controlSeleccionarDepartamento(descPregunta, pregunta, tmp, contenedorCaracteristicas, required, campoAdicional);
          }
        }
      }
    } else if (pregunta.desc_tipo_dato === TipoCampoAdicional.Multiple) { // Pregunta tipo MULTIPLE
      // Contenedor de las opciones
      let contenedorOpciones = document.createElement("div");
      contenedorPregunta.append(contenedorOpciones);

      let tituloMultiple = document.createElement("p");
      tituloMultiple.textContent = campoAdicional ? pregunta.titulo : pregunta.desc_documento + ':';
      tituloMultiple.className = required;
      contenedorOpciones.append(tituloMultiple);

      this.arrayIdInput.push(
        {
          required: required,
          idInput: 'input_' + (campoAdicional ? 'campoAdicional_' + pregunta.campo_adicional_id : 'doc_' + pregunta.documento_id),
          id: campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id,
          inputType: pregunta.desc_tipo_dato,
          idPrincipal: ''
        }
      );

      // Mostrar las opciones
      let listOpciones = pregunta.opciones;
      for (let i = 0; i < listOpciones.length; i++) {
        let tmp = listOpciones[i];
        let idDocumentoPadre = (campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id);

        let radio = document.createElement("input");
        let haveSon = tmp.preguntas_hijas.length > 0 ? '1' : '0';
        let pregHijas = haveSon === '1' ? tmp.preguntas_hijas : false;
        let idPregHija = haveSon === '1' ? (campoAdicional ? tmp.preguntas_hijas[0].campo_adicional_id : tmp.preguntas_hijas[0].documento_id) : false;

        radio.type = "radio";
        radio.value = tmp.valor;
        radio.name = "preguntaPadre_" + idDocumentoPadre;
        radio.className = 'mr-1 ml-2 input_' + (campoAdicional ? 'campoAdicional_' + pregunta.campo_adicional_id : 'doc_' + pregunta.documento_id);;
        radio.setAttribute('data-haveSon', haveSon);
        radio.setAttribute('data-idPregHija', idPregHija);
        radio.checked = tmp.valor === pregunta.valor ? true : false;
        radio.addEventListener('change', (event) => {

          let valueSelected = (<HTMLInputElement>event.target).value;
          pregunta.valor = valueSelected;
          let valorHijo = (<HTMLInputElement>event.target).getAttribute('data-idpreghija');
          let tieneHijo = (<HTMLInputElement>event.target).getAttribute('data-haveSon');
          let contenedor = document.getElementById('div_pregunta_' + (campoAdicional ? 'campoAdicional_' : 'doc_') + idDocumentoPadre).getElementsByTagName('div');
          let hijo = (<HTMLInputElement>document.getElementById('div_pregunta_' + (campoAdicional ? 'campoAdicional_' : 'doc_') + idDocumentoPadre).lastChild);

          // Eliminamos las preguntas hijas que se ESTAN mostrando
          if (tieneHijo == '0' || (hijo?.id != 'div_pregunta' + (campoAdicional ? 'campoAdicional_' : 'doc_') + valorHijo)) {
            if (contenedor.length > 1) {
              //TODO:: Validar eliminacion de items en array.
              let inputs: any = (<HTMLCollection>document.getElementsByClassName('input_' + (campoAdicional ? 'campoAdicional_' : 'doc_') + idDocumentoPadre));
              let idHijoChange;
              this.arrayHijos = [];
              for (let element of inputs) {
                this.arrayHijos.push(element.getAttribute('data-idpreghija'));
              }

              idHijoChange = this.arrayHijos.find((value) => value != false);
              this.buscarArrayHijosMultiple(idHijoChange);
              this.arrayHijos = this.arrayHijos.filter((value) => value != 'false');

              // procedimiento para eliminar los hijos
              if (campoAdicional) {
                for (var item of this.arrayHijos) {
                  this.arrayIdInputAdicional = this.arrayIdInputAdicional.filter((value) => value.id != item);
                }
              } else {
                for (var item of this.arrayHijos) {
                  this.arrayIdInput = this.arrayIdInput.filter((value) => value.id != item);
                }
              }

              document.getElementById('div_pregunta_' + (campoAdicional ? 'campoAdicional_' : 'doc_') + idDocumentoPadre).lastChild.remove();
            }
          }

          if (pregHijas != false) {
            this.mostrarPreguntasHijas(pregHijas, idDocumentoPadre, campoAdicional);
          }
          //this.guardarCampoDocumento(this.idDocPadreMultCarac, false);
          this.guardarCampoDocumento(campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id, false, pregunta, campoAdicional);
          this.validarForm();
        });
        contenedorOpciones.append(radio);

        let descPregunta = document.createElement("label");
        descPregunta.textContent = tmp.descripcion;
        contenedorOpciones.append(descPregunta);

        // Cuando ya tiene data guardada
        if (tmp.valor === pregunta.valor) {
          // Mostramos las preguntas hijas
          if (haveSon === '1') {
            this.mostrarPreguntasHijas(pregHijas, idDocumentoPadre, campoAdicional);
          }
        }
      }

      this.idDocPadreMultCarac = 0;
    } else if (pregunta.desc_tipo_dato === TipoCampoAdicional.VariosRegistros) { // Pregunta tipo VARIOS REGISTROS
      this.arrayDocumentoVariosRegistros = this.arrayDocumentoVariosRegistros.filter(x => x.idPrincipal != (campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id) && x.campoAdicional === campoAdicional);
      // Verificar si hay datos guardados
      let tempArray: Array<any> = [];
      if (pregunta.valor_varios_registros) {
        tempArray = (pregunta.valor_varios_registros).split('-');

        for (let i = 0; i < tempArray.length; i++) {
          let obj = tempArray[i];

          this.arrayDocumentoVariosRegistros.push({
            id: i + 1,
            value: obj,
            idPrincipal: campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id,
            campoAdicional: campoAdicional
          });
        }
      } else {
        this.arrayDocumentoVariosRegistros.push({
          id: 1,
          value: '',
          idPrincipal: campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id,
          campoAdicional: campoAdicional
        });
      }

      let tituloVariosRegistros = document.createElement("p");
      tituloVariosRegistros.textContent = campoAdicional ? pregunta.titulo : pregunta.desc_documento + ':';
      tituloVariosRegistros.className = required;
      contenedorPregunta.append(tituloVariosRegistros);

      if (pregunta.nombre_varios_registros != null && pregunta.nombre_varios_registros != undefined && pregunta.nombre_varios_registros != '') {
        let label = document.createElement('label');
        label.textContent = pregunta.nombre_varios_registros;
        contenedorPregunta.append(label);
      }

      // Contenedor de los registros
      let contenedorRegistros = document.createElement("div");
      contenedorPregunta.append(contenedorRegistros);

      let arraytempVariosRegistros = this.arrayDocumentoVariosRegistros.filter(x => x.idPrincipal === (campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id) && x.campoAdicional === campoAdicional);

      // Creamos el listado de respuesta
      let ul = document.createElement('ul');
      ul.className = 'list-unstyled';
      ul.id = 'listaVariosRegistros_' + (campoAdicional ? 'campoAdicional_' + pregunta.campo_adicional_id : 'doc_' + pregunta.documento_id);
      for (let j = 0; j < arraytempVariosRegistros.length; j++) {
        let itemVarioRegistro = arraytempVariosRegistros[j];
        let li = document.createElement('li');
        li.style.marginBottom = "6px";
        li.id = 'containerVariosRegistroItem_' + itemVarioRegistro.id + '_' + (campoAdicional ? 'campoAdicional_' + pregunta.campo_adicional_id : 'doc_' + pregunta.documento_id);

        // Contenedor Input y Btn Delete
        let divInputBtn = document.createElement('div');
        divInputBtn.className = 'd-flex';
        li.append(divInputBtn);

        // Contendor Input
        let divInput = document.createElement('div');
        divInputBtn.append(divInput);

        let input = document.createElement('input');
        input.className = "form-control";
        input.id = 'input_' + (campoAdicional ? 'campo_adicional_' + pregunta.campo_adicional_id : 'campo_doc_' + pregunta.documento_id) + '_' + j;
        input.type = 'text';
        input.setAttribute('data-id', itemVarioRegistro.id);
        input.value = itemVarioRegistro.value;
        input.addEventListener(('change'), event => {
          let idArray = Number((<HTMLInputElement>event.target).getAttribute('data-id'));
          let valueType = (<HTMLInputElement>event.target).value;
          let itemToAdd = this.arrayDocumentoVariosRegistros.find(element => element.id == idArray && element.idPrincipal === (campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id) && element.campoAdicional === campoAdicional);
          let tempArrayDocumentoVariosRegistros: Array<any> = [];

          itemToAdd.value = valueType;
          let arraytempVariosRegistros = this.arrayDocumentoVariosRegistros.filter(x => x.idPrincipal === (campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id) && x.campoAdicional === campoAdicional);

          for (let i = 0; i < arraytempVariosRegistros.length; i++) {
            tempArrayDocumentoVariosRegistros.push(arraytempVariosRegistros[i].value);
          }

          //this.arrayDocumentoVariosRegistros.filter(Boolean);
          pregunta.valor_varios_registros = tempArrayDocumentoVariosRegistros.join('-');

          this.guardarCampoDocumento(campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id, false, pregunta, campoAdicional);
          this.validarForm();
        });
        divInput.appendChild(input);

        // Contenedor Btn
        let divBtn = document.createElement('div');
        divBtn.className = 'pl-3';
        divInputBtn.append(divBtn);

        // Img Btn
        let imgBtn = document.createElement('img');
        imgBtn.src = 'assets/icons/delete.png';
        imgBtn.width = 30;

        // Btn eliminar
        let buttonDel = document.createElement('a');
        buttonDel.href = 'javascript:void(0)';
        buttonDel.setAttribute('data-id', itemVarioRegistro.id);
        buttonDel.addEventListener(('click'), () => {
          let idDelete = buttonDel.getAttribute('data-id');
          this.eliminarVariosRegistros(pregunta, idDelete, 'documento', campoAdicional);
          this.validarForm();
        });
        buttonDel.append(imgBtn);
        divBtn.appendChild(buttonDel);

        ul.appendChild(li);
      }
      contenedorRegistros.appendChild(ul);

      // Contenedor del btn "Agregar Registro"
      let contenedorBoton = document.createElement("div");
      contenedorBoton.className = 'text-center';
      contenedorPregunta.append(contenedorBoton);
      // Boton
      let button = document.createElement('button');
      button.type = 'button';
      button.className = 'btn btn-secondary btn-sm';
      button.textContent = 'Agregar Registro';
      contenedorBoton.append(button);
      button.addEventListener('click', () => {
        this.variosRegistrosAddInputDocumento(campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id, pregunta.nombre_varios_registros, pregunta, campoAdicional);
      });

      if (campoAdicional) {
        this.arrayIdInputAdicional.push({ required: required, idInput: 'input_campoAdicional_' + pregunta.campo_adicional_id, id: pregunta.campo_adicional_id, inputType: pregunta.desc_tipo_dato, idPrincipal: '', idHija: '' })
      } else {
        this.arrayIdInput.push({ required: required, idInput: 'input_doc_' + pregunta.documento_id, id: pregunta.documento_id, inputType: pregunta.desc_tipo_dato, idPrincipal: '', idHija: '' });
      }
    }
  }

  controlSeleccionarTipoDocumento(descPregunta, pregunta, tmp, contenedorCaracteristicas, required, campoAdicional) {
    let select = document.createElement("select");
    select.className = "form-control";
    select.id = 'input_' + (campoAdicional ? 'campoAdicional_' + tmp.caracteristicas_campo_adicional_opciones_id : 'doc_' + tmp.caracteristicas_documento_opciones_id);
    select.setAttribute('data-idCaracteristicaDoc', (campoAdicional ? tmp.caracteristicas_campo_adicional_opciones_id : tmp.caracteristicas_documento_opciones_id));
    select.addEventListener('change', (event) => {
      let valueSelected = (<HTMLSelectElement>event.target).value;

      // Buscar la caracteristica que se modifico
      let itemModify;
      if (campoAdicional) {
        itemModify = (pregunta.caracteristicas_Opciones).find(element => element.caracteristicas_campo_adicional_opciones_id == tmp.caracteristicas_campo_adicional_opciones_id);
      } else {
        itemModify = (pregunta.caracteristicas_Opciones).find(element => element.caracteristicas_documento_opciones_id == tmp.caracteristicas_documento_opciones_id);
      }
      itemModify.Valor_Registros = valueSelected

      this.guardarCampoDocumento((campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id), (campoAdicional ? tmp.caracteristicas_campo_adicional_opciones_id : tmp.caracteristicas_documento_opciones_id), pregunta, campoAdicional);
      this.validarForm();
    });

    descPregunta.textContent = tmp.descripcion;
    contenedorCaracteristicas.append(descPregunta);

    let optionNull = document.createElement("option");
    optionNull.setAttribute("value", "");
    let optionNullTexto = document.createTextNode("Seleccione");
    optionNull.appendChild(optionNullTexto);
    select.appendChild(optionNull);

    this.tipos_identificaciones.forEach(element => {
      let option = document.createElement("option");
      option.setAttribute("value", element.tipo_identificacion_id);
      let optionTexto = document.createTextNode(element.descripcion);
      option.appendChild(optionTexto);
      select.appendChild(option);
    });
    select.value = tmp.Valor_Registros == null ? '' : tmp.Valor_Registros;
    contenedorCaracteristicas.append(select);

    if (campoAdicional) {
      this.arrayIdInputAdicional.push({ required: required, idInput: 'input_campoAdicional_' + tmp.caracteristicas_campo_adicional_opciones_id, id: tmp.caracteristicas_campo_adicional_opciones_id, inputType: tmp.caracteristicas_opciones_descripcion, idPrincipal: pregunta.campo_adicional_id, idHija: '' })
    } else {
      this.arrayIdInput.push({
        required: required, idInput: 'input_doc_' + tmp.caracteristicas_documento_opciones_id,
        id: tmp.caracteristicas_documento_opciones_id, inputType: tmp.caracteristicas_opciones_descripcion, idPrincipal: pregunta.documento_id, idHija: ''
      });
    }
  }

  controlSeleccionarDepartamento(descPregunta, pregunta, tmp, contenedorCaracteristicas, required, campoAdicional) {
    let select = document.createElement("select");
    select.className = "form-control";
    select.id = 'input_' + (campoAdicional ? 'campoAdicional_departamento_' + tmp.caracteristicas_campo_adicional_opciones_id : 'doc_departamento_' + tmp.caracteristicas_documento_opciones_id);
    //select.setAttribute('data-idCaracteristicaDoc', tmp.caracteristicas_documento_opciones_id);

    //TODO:: Organizar el cambio de dato.
    select.addEventListener('change', (event) => {
      let valueSelected = (<HTMLSelectElement>event.target).value;

      // Buscar la caracteristica que se modifico
      let itemModify;
      if (campoAdicional) {
        itemModify = (pregunta.caracteristicas_Opciones).find(element => element.caracteristicas_campo_adicional_opciones_id == tmp.caracteristicas_campo_adicional_opciones_id);
      } else {
        itemModify = (pregunta.caracteristicas_Opciones).find(element => element.caracteristicas_documento_opciones_id == tmp.caracteristicas_documento_opciones_id);
      }
      itemModify.id_auxiliar = valueSelected

      //this.guardarCampoDocumento(pregunta.documento_id, tmp.caracteristicas_documento_opciones_id, pregunta);
      this.basicasLoVService.getMunicipiosxDepartamento(valueSelected).subscribe(resultado => {
        if (resultado.result) {
          this.municipios = resultado.data as Array<MunicipioEntry>;
          this.opcionesMunicipos('input_docMC_' + tmp.caracteristicas_documento_opciones_id);
        }
      });

      this.validarForm();
    });

    descPregunta.textContent = "Departamento";
    contenedorCaracteristicas.append(descPregunta);

    let optionNull = document.createElement("option");
    optionNull.setAttribute("value", "");
    let optionNullTexto = document.createTextNode("Seleccione");
    optionNull.appendChild(optionNullTexto);
    select.appendChild(optionNull);

    this.departamentos.forEach(element => {
      let option = document.createElement("option");
      option.setAttribute("value", element.departamento_id.toString());
      let optionTexto = document.createTextNode(element.descripcion);
      option.appendChild(optionTexto);
      select.appendChild(option);
    });

    select.value = tmp.id_auxiliar == null ? '' : tmp.id_auxiliar;
    contenedorCaracteristicas.append(select);
    if (campoAdicional) {
      this.arrayIdInputAdicional.push({ required: required, idInput: 'input_campoAdicional_departamento_' + tmp.caracteristicas_campo_adicional_opciones_id, id: tmp.caracteristicas_campo_adicional_opciones_id, inputType: tmp.caracteristicas_opciones_descripcion, idPrincipal: pregunta.campo_adicional_id, idHija: '' })
    } else {
      this.arrayIdInput.push({
        required: required, idInput: 'input_doc_departamento_' + tmp.caracteristicas_documento_opciones_id,
        id: tmp.caracteristicas_documento_opciones_id, inputType: tmp.caracteristicas_opciones_descripcion, idPrincipal: pregunta.documento_id, idHija: ''
      });
    }

    if (select.value !== '') {
      this.basicasLoVService.getMunicipiosxDepartamento(tmp.id_auxiliar).subscribe(resultado => {
        if (resultado.result) {
          this.municipios = resultado.data as Array<MunicipioEntry>;
          this.controlSeleccionarMunicipio(document.createElement("label"), pregunta, tmp, contenedorCaracteristicas, required, campoAdicional);
        }
      });
    } else {
      this.controlSeleccionarMunicipio(document.createElement("label"), pregunta, tmp, contenedorCaracteristicas, required, campoAdicional);
    }
  }

  controlSeleccionarMunicipio(descPregunta, pregunta, tmp, contenedorCaracteristicas, required, campoAdicional) {
    let select = document.createElement("select");
    select.className = "form-control";
    select.id = 'input_docMC_' + tmp.caracteristicas_documento_opciones_id;
    select.setAttribute('data-idCaracteristicaDoc', tmp.caracteristicas_documento_opciones_id);
    select.setAttribute('disabled', 'disabled');

    select.addEventListener('change', (event) => {
      let valueSelected = (<HTMLSelectElement>event.target).value;

      // Buscar la caracteristica que se modifico
      let itemModify;
      if (campoAdicional) {
        itemModify = (pregunta.caracteristicas_Opciones).find(element => element.caracteristicas_campo_adicional_opciones_id == tmp.caracteristicas_campo_adicional_opciones_id);
      } else {
        itemModify = (pregunta.caracteristicas_Opciones).find(element => element.caracteristicas_documento_opciones_id == tmp.caracteristicas_documento_opciones_id);
      }
      itemModify.Valor_Registros = valueSelected

      this.guardarCampoDocumento((campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id), (campoAdicional ? tmp.caracteristicas_campo_adicional_opciones_id : tmp.caracteristicas_documento_opciones_id), pregunta, campoAdicional);
      this.validarForm();
    });

    descPregunta.textContent = tmp.descripcion;
    contenedorCaracteristicas.append(descPregunta);

    let optionNull = document.createElement("option");
    optionNull.setAttribute("value", "");
    let optionNullTexto = document.createTextNode("Seleccione");
    optionNull.appendChild(optionNullTexto);
    select.appendChild(optionNull);

    if (this.municipios !== undefined && this.municipios !== null) {
      select.removeAttribute('disabled');
      this.municipios.forEach(element => {
        let option = document.createElement("option");
        option.setAttribute("value", element.municipio_id.toString());
        let optionTexto = document.createTextNode(element.descripcion);
        option.appendChild(optionTexto);
        select.appendChild(option);
      });
    }

    select.value = tmp.Valor_Registros == null ? '' : tmp.Valor_Registros;
    contenedorCaracteristicas.append(select);

    if (campoAdicional) {
      this.arrayIdInputAdicional.push({
        required: required, idInput: 'input_campoAdicional_' + tmp.caracteristicas_campo_adicional_opciones_id, id: tmp.caracteristicas_campo_adicional_opciones_id,
        inputType: tmp.caracteristicas_opciones_descripcion, idPrincipal: pregunta.campo_adicional_id, idHija: ''
      })
    } else {
      this.arrayIdInput.push({
        required: required, idInput: 'input_doc_' + tmp.caracteristicas_documento_opciones_id,
        id: tmp.caracteristicas_documento_opciones_id, inputType: tmp.caracteristicas_opciones_descripcion, idPrincipal: pregunta.documento_id, idHija: ''
      });
    }
  }

  opcionesMunicipos(idInput) {
    let select = <HTMLSelectElement>document.getElementById(idInput)
    let pruebaSelect = document.getElementById(idInput)
    pruebaSelect.removeAttribute('disabled');

    if (select.options) {
      while (select.options.length > 1) {
        select.remove(1);
      }
    }

    this.municipios.forEach(element => {
      let option = document.createElement("option");
      option.setAttribute("value", element.municipio_id.toString());
      let optionTexto = document.createTextNode(element.descripcion);
      option.appendChild(optionTexto);
      select.appendChild(option);
    });

    select.value = '';
  }

  mostrarPreguntasHijas(pregHijas, idDocumentoPadre, campoAdicional) {
    let totPreguntasHijas = pregHijas.length
    let mostrarPregHijas = totPreguntasHijas > 0 ? true : false;

    if (mostrarPregHijas) {
      let contenedorPadre = document.getElementById('div_pregunta_' + (campoAdicional ? 'campoAdicional_' : 'doc_') + idDocumentoPadre);
      // Contenedor de las opciones
      let contenedorPreguntasHijas = document.createElement("div");
      contenedorPreguntasHijas.className = "pl-1";
      contenedorPreguntasHijas.setAttribute('id', 'div_pregunta_' + (campoAdicional ? 'campoAdicional_' + pregHijas[0].campo_adicional_id : 'doc_' + pregHijas[0].documento_id));
      contenedorPadre.append(contenedorPreguntasHijas);

      //TODO:: Revisar la parte de varios registros, tiene errores al eliminar el hijo. (Duplicidad)
      let preguntasHijas = pregHijas[0];
      //if (preguntasHijas.desc_tipo_dato !== TipoCampoAdicional.VariosRegistros) {
      this.generarTipoPreguntaDocumento(preguntasHijas, contenedorPreguntasHijas, campoAdicional);
      //}
    }
  }

  guardarCampoDocumento(idDocument, idDocumentCarac, newPregunta, campoAdicional) {
    let respuestaPregunta: any;

    if (newPregunta) {
      // VARCHAR/BIGINT/TEXTAREA
      if ((newPregunta.desc_tipo_dato === TipoCampoAdicional.Fecha) || (newPregunta.desc_tipo_dato === TipoCampoAdicional.Numerico) || (newPregunta.desc_tipo_dato === TipoCampoAdicional.Texto) || (newPregunta.desc_tipo_dato === TipoCampoAdicional.TextArea)) {
        respuestaPregunta = (<HTMLInputElement>document.getElementById('input_' + (campoAdicional ? 'campoAdicional_' : 'doc_') + idDocument)).value;
        newPregunta.valor = respuestaPregunta;
      } else if (newPregunta.desc_tipo_dato === TipoCampoAdicional.Booleano) { //BIT
        respuestaPregunta = document.getElementById('input_' + (campoAdicional ? 'campoAdicional_' : 'doc_') + idDocument) as HTMLInputElement | null;
        respuestaPregunta = respuestaPregunta.checked ? '1' : '0';
        newPregunta.valor = respuestaPregunta;
      } else if (newPregunta.desc_tipo_dato === TipoCampoAdicional.MultipleCaracteristica) { // MULTIPLE CARACTERISTICA
        /*let listPreguntasMultipleCarac = newPregunta.caracteristicas_Opciones;
        let preguntaMultipleCarac = listPreguntasMultipleCarac.find(element => element.caracteristicas_documento_opciones_id == idDocumentCarac);
        respuestaPregunta = (<HTMLInputElement>document.getElementById('input_doc_' + idDocumentCarac)).value;

        preguntaMultipleCarac.Valor_Registros = respuestaPregunta;*/
      }
    } else {
      console.log('No se encontro el ID DOC, en la pregunta')
    }

    if (campoAdicional) {
      this.tipoEstablecimientoService.updateCampoAdicional({ ...newPregunta } as CampoAdicionalEntry).subscribe(resultado => {
        if (resultado.result) {
          if ((this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion)
            || (this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Actualizacion)
            || (this.datoSolicitudSharedModel.data.estado_rnt_id ===
              EstadosRnt.SuspendidoPorNoRenovar &&
              this.datoSolicitudSharedModel.tipo_solicitud ===
              TipoSolicitud.Reactivacion)) {
            this.ratificaInformacion.cantidad_modificaciones += 1;
            this.completaInformacionService.confirmarCambio({ ...this.rnt, ...this.ratificaInformacion }).subscribe();
          }
        }
      });
    } else {
      this.tipoEstablecimientoService.update(
        { ...newPregunta } as DocumentoEntry).subscribe(resultado => {
          if (resultado.result) {
            if ((this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion)
              || (this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Actualizacion)
              || (this.datoSolicitudSharedModel.data.estado_rnt_id ===
                EstadosRnt.SuspendidoPorNoRenovar &&
                this.datoSolicitudSharedModel.tipo_solicitud ===
                TipoSolicitud.Reactivacion)) {
              this.ratificaInformacion.cantidad_modificaciones += 1;
              this.completaInformacionService.confirmarCambio({ ...this.rnt, ...this.ratificaInformacion }).subscribe();
            }
          }
        });
    }
  }

  variosRegistrosAddInputDocumento(documento_id, nombre_varios_registros, pregunta, campoAdicional) {
    let arraytempVariosRegistros = this.arrayDocumentoVariosRegistros.filter(x => x.idPrincipal === documento_id && x.campoAdicional === campoAdicional);
    let lista = document.getElementById('listaVariosRegistros_' + (campoAdicional ? 'campoAdicional_' : 'doc_') + documento_id);
    let totalVariosRegistro = arraytempVariosRegistros.length - 1;
    let i = arraytempVariosRegistros[totalVariosRegistro].id + 1;

    this.arrayDocumentoVariosRegistros.push({
      id: i,
      value: '',
      idPrincipal: documento_id,
      campoAdicional: campoAdicional
    });

    let li = document.createElement('li');
    li.style.marginBottom = "6px";
    li.id = 'containerVariosRegistroItem_' + i + '_' + (campoAdicional ? 'campoAdicional_' : 'doc_') + documento_id;

    // let label = document.createElement('label');
    // label.textContent = nombre_varios_registros;
    // li.append(label);

    // Conenedor Input y Btn Delete
    let divInputBtn = document.createElement('div');
    divInputBtn.className = 'd-flex';
    li.append(divInputBtn);

    // Contendor Input
    let divInput = document.createElement('div');
    divInputBtn.append(divInput);

    let input = document.createElement('input');
    input.className = "form-control";
    input.id = 'input_' + (campoAdicional ? 'campoAdicional_' : 'doc_') + documento_id + '_' + i;
    input.type = 'text';
    input.setAttribute('data-id', i);
    input.addEventListener(('change'), event => {
      let idArray = Number((<HTMLInputElement>event.target).getAttribute('data-id'));
      let valueType = (<HTMLInputElement>event.target).value;
      let itemToAdd = this.arrayDocumentoVariosRegistros.find(element => element.id == idArray && element.idPrincipal === (campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id) && element.campoAdicional === campoAdicional);
      let tempArrayDocumentoVariosRegistros: Array<any> = [];

      itemToAdd.value = valueType;
      let arraytempVariosRegistros = this.arrayDocumentoVariosRegistros.filter(x => x.idPrincipal === (campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id) && x.campoAdicional === campoAdicional);

      for (let i = 0; i < arraytempVariosRegistros.length; i++) {
        tempArrayDocumentoVariosRegistros.push(arraytempVariosRegistros[i].value);
      }

      pregunta.valor_varios_registros = tempArrayDocumentoVariosRegistros.join('-');

      this.guardarCampoDocumento((campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id), false, pregunta, campoAdicional);
      this.validarForm();
    });
    divInput.appendChild(input);

    // Contenedor Btn
    let divBtn = document.createElement('div');
    divBtn.className = 'pl-3';
    divInputBtn.append(divBtn);

    // Img Btn
    let imgBtn = document.createElement('img');
    imgBtn.src = 'assets/icons/delete.png';
    imgBtn.width = 30;

    // Btn eliminar
    let buttonDel = document.createElement('a');
    buttonDel.setAttribute('data-id', i.toString());
    buttonDel.addEventListener(('click'), () => {
      let idDelete = buttonDel.getAttribute('data-id');
      this.eliminarVariosRegistros(pregunta, idDelete, 'documento', campoAdicional);
      this.validarForm();
    });
    buttonDel.append(imgBtn);
    divBtn.appendChild(buttonDel);

    lista.appendChild(li);
    this.validarForm();
  }

  //TODO:: Validaciones lado derecho.
  //arrayIdInput, guarda todas las preguntas (Hijas, y las carac.)
  //inputPrincipales, obtiene solo las preguntas requeridas y padres de padres
  isDisabled: boolean = false;
  arrayIdInput: Array<any> = [];
  arrayIdInputAdicional: Array<any> = [];
  validarForm() {
    this.isDisabled = false;
    let inputPrincipales = this.arrayIdInput.filter((value) => value.required == 'required' && value.idPrincipal === '');
    inputPrincipales = inputPrincipales.concat(this.arrayIdInputAdicional.filter((value) => value.required == 'required' && value.idPrincipal === ''));

    for (let i = 0; i < inputPrincipales.length; i++) {
      let tmp = inputPrincipales[i];
      if (tmp.inputType === TipoCampoAdicional.Texto || tmp.inputType === TipoCampoAdicional.Numerico
        || tmp.inputType === TipoCampoAdicional.TextArea || tmp.inputType === TipoCampoAdicional.Fecha) {
        let input = (<HTMLInputElement>document.getElementById(tmp.idInput)).value;
        if (input === '') {
          this.isDisabled = true;
          return this.isDisabled;
        } else if (tmp.es_numero_positivo) {
          this.isDisabled = !this.validarCampoNumericoEnteroPositivo(<HTMLInputElement>document.getElementById(tmp.idInput));
          if (this.isDisabled) {
            return this.isDisabled;
          }
        }
      } else if (tmp.inputType === TipoCampoAdicional.Booleano) {
        let input = (<HTMLInputElement>document.getElementById(tmp.idInput)).checked;
        if (input === false) {
          this.isDisabled = true;
          return this.isDisabled;
        }
      } else if (tmp.inputType === TipoCampoAdicional.MultipleCaracteristica) {
        let itemsCaracteristicas = this.arrayIdInput.filter((value) => value.idPrincipal == tmp.id);
        if (itemsCaracteristicas.length == 0) {
          itemsCaracteristicas = this.arrayIdInputAdicional.filter((value) => value.idPrincipal == tmp.id);
        }

        for (let i = 0; i < itemsCaracteristicas?.length; i++) {
          let caracteristica = itemsCaracteristicas[i];
          if (caracteristica.inputType === TipoCampoAdicional.Texto || caracteristica.inputType === TipoCampoAdicional.Numerico
            || caracteristica.inputType === TipoCampoAdicional.Fecha) {
            let input = (<HTMLInputElement>document.getElementById(caracteristica.idInput)).value;
            if (input === '') {
              this.isDisabled = true;
              return this.isDisabled;
            }
          } else if (caracteristica.inputType == TipoCampoAdicional.TipoDocumento ||
            caracteristica.inputType == TipoCampoAdicional.Municipio) {
            let input = (<HTMLSelectElement>document.getElementById(caracteristica.idInput)).value;
            if (input === '') {
              this.isDisabled = true;
              return this.isDisabled;
            }
          }
        }
      } else if (tmp.inputType === TipoCampoAdicional.Multiple) {
        let inputs: any = (<HTMLCollection>document.getElementsByClassName(tmp.idInput));
        for (let element of inputs) {
          if (element.checked && element.getAttribute('data-idpreghija') != 'false') {
            this.validarMultiple(element.getAttribute('data-idpreghija'));
          }
        }
      } else if (tmp.inputType === TipoCampoAdicional.VariosRegistros) {
        let itemsObligatorios = this.arrayDocumentoVariosRegistros.filter(x => x.idPrincipal == tmp.id && (x.value === '' || x.value === undefined || x.value === null));
        if (itemsObligatorios.length > 0) {
          this.isDisabled = true;
          return this.isDisabled;
        }
      }
    }

    return this.isDisabled;
  }

  validarMultiple(idHijo) {
    let items = this.arrayIdInputAdicional.filter((value) => value.id == idHijo);
    if (items.length == 0) {
      items = this.arrayIdInputAdicional.filter((value) => value.id == idHijo);
    }
    for (let i = 0; i < items.length; i++) {
      let item = items[i];
      if (item.inputType === TipoCampoAdicional.Multiple) {
        let inputs: any = (<HTMLCollection>document.getElementsByClassName(item.idInput));
        let countTrue = 0;

        for (let element of inputs) {
          if (element.checked) {
            countTrue++
          }

          if (element.getAttribute('data-idpreghija') != 'false' && element.checked) {
            this.validarMultiple(element.getAttribute('data-idpreghija'));
          }
        };

        this.isDisabled = this.isDisabled == false ? countTrue == 0 : true;
        return this.isDisabled;
      } else if (item.inputType === TipoCampoAdicional.Texto || item.inputType === TipoCampoAdicional.Numerico
        || item.inputType === TipoCampoAdicional.TextArea || item.inputType === TipoCampoAdicional.Fecha) {
        let input = (<HTMLInputElement>document.getElementById(item.idInput)).value;
        if (input === '') {
          this.isDisabled = true;
          return this.isDisabled;
        }
      } else if (item.inputType === TipoCampoAdicional.Booleano) {
        let input = (<HTMLInputElement>document.getElementById(item.idInput)).checked;
        if (input === false) {
          this.isDisabled = true;
          return this.isDisabled;
        }
      } else if (item.inputType === TipoCampoAdicional.MultipleCaracteristica) {
        let itemsCaracteristicas = this.arrayIdInput.filter((value) => value.idPrincipal == item.id);
        for (let i = 0; i < itemsCaracteristicas.length; i++) {
          let caracteristica = itemsCaracteristicas[i];
          if (caracteristica.inputType === TipoCampoAdicional.Texto || caracteristica.inputType === TipoCampoAdicional.Numerico || caracteristica.inputType === TipoCampoAdicional.Fecha) {
            let input = (<HTMLInputElement>document.getElementById(caracteristica.idInput)).value;
            if (input === '') {
              this.isDisabled = true;
              return this.isDisabled;
            }
          }
        }
      } else if (item.inputType === TipoCampoAdicional.VariosRegistros) {
        let itemsObligatorios = this.arrayDocumentoVariosRegistros.filter(x => x.idPrincipal == item.id && (x.value === '' || x.value === undefined || x.value === null));
        if (itemsObligatorios.length > 0) {
          this.isDisabled = true;
          return this.isDisabled;
        }
      }
    }

    return this.isDisabled = false;
  }

  arrayHijos: Array<any> = [];
  buscarArrayHijosMultiple(idHijo) {
    let items = this.arrayIdInput.filter((value) => value.id == idHijo);
    if (items.length == 0) {
      items = this.arrayIdInputAdicional.filter((value) => value.id == idHijo);
    }

    for (let i = 0; i < items.length; i++) {
      let item = items[i];
      if (item.inputType === TipoCampoAdicional.Multiple) {
        let inputs: any = (<HTMLCollection>document.getElementsByClassName(item.idInput));

        for (let element of inputs) {
          this.arrayHijos.push(element.getAttribute('data-idpreghija'));
          this.buscarArrayHijosMultiple(element.getAttribute('data-idpreghija'));
        };
      } else if (item.inputType === TipoCampoAdicional.MultipleCaracteristica) {
        let itemsCaracteristicas = this.arrayIdInput.filter((value) => value.idPrincipal == item.id);
        for (let i = 0; i < itemsCaracteristicas.length; i++) {
          let caracteristica = itemsCaracteristicas[i];
          if (caracteristica.inputType === TipoCampoAdicional.Texto || caracteristica.inputType === TipoCampoAdicional.Numerico || caracteristica.inputType === TipoCampoAdicional.Fecha) {
            this.arrayHijos.push(caracteristica.id);
          }
        }
      }
    }
  }

  // Eliminar respuesta Varios Registro
  eliminarVariosRegistros(pregunta, index, option, campoAdicional) {
    this.alertService.clear();
    let tempArrayDocumentoVariosRegistros: Array<any> = [];

    if (option === 'documento') {
      if (this.arrayDocumentoVariosRegistros.filter(x => x.idPrincipal === (campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id) && x.campoAdicional === campoAdicional).length > 1) {
        // FYI: la variable index, se convierte en el id a eliminar
        let arraytempVariosRegistros = this.arrayDocumentoVariosRegistros.filter(x => x.idPrincipal === (campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id) && x.campoAdicional === campoAdicional);
        let itemToDelete = arraytempVariosRegistros.find(element => element.id == index && element.idPrincipal === (campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id));

        const itemIndexToDelete = this.arrayDocumentoVariosRegistros.findIndex(object => {
          return object.id === itemToDelete.id && object.idPrincipal === itemToDelete.idPrincipal && object.campoAdicional === campoAdicional;
        });
        let itemListaToDelete = document.getElementById('containerVariosRegistroItem_' + itemToDelete.id + '_' + (campoAdicional ? 'campoAdicional_' + pregunta.campo_adicional_id : 'doc_' + pregunta.documento_id));

        // Eliminamos el item de la UL
        itemListaToDelete.remove();

        // Eliminamos el item del array
        this.arrayDocumentoVariosRegistros.splice(itemIndexToDelete, 1);
        arraytempVariosRegistros = this.arrayDocumentoVariosRegistros.filter(x => x.idPrincipal === (campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id) && x.campoAdicional === campoAdicional);

        for (let i = 0; i < arraytempVariosRegistros.length; i++) {
          tempArrayDocumentoVariosRegistros.push(arraytempVariosRegistros[i].value);
        }
        pregunta.valor_varios_registros = tempArrayDocumentoVariosRegistros.join('-');
        this.guardarCampoDocumento((campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id), false, pregunta, campoAdicional);
      } else if (this.arrayDocumentoVariosRegistros.filter(x => x.idPrincipal === (campoAdicional ? pregunta.campo_adicional_id : pregunta.documento_id) && x.campoAdicional === campoAdicional).length === 1) {
        this.alertService.warn(
          "La pregunta que esta respondiendo, debe tener al menos una respuesta",
          null,
          null
        );
      }
    }
  }

  get tieneAutorizaPropiedadHorizontalCtrl(): AbstractControl | undefined {
    return this.formTipoEstablecimiento.get(this.campos_tieneautoriza_propiedad_horizontal.desc_campo_adicional);
  }

  private validarCampoNumericoEnteroPositivo(input: HTMLInputElement): boolean {
    if (!input.value.match(/^[1-9]+([0-9]*){0,1}$/g)) {
      this.addErrorMessage(input.parentElement, "Solo se permiten valores numéricos enteros positivos");
      return false;
    } else {
      this.clearErrorMessages(input.parentElement);
      return true;
    }
  }

  private addErrorMessage(container: HTMLElement, errorMessage: string) {
    var errorMessageElement = container.querySelector(".error-message");
    if (errorMessageElement) {
      errorMessageElement.textContent = errorMessage;
      return;
    }

    errorMessageElement = document.createElement("p");
    errorMessageElement.className = "error-message small text-danger my-1 font-weight-bold";
    errorMessageElement.textContent = errorMessage;
    container.appendChild(errorMessageElement);
  }

  private clearErrorMessages(container: HTMLElement) {
    var errorElements = container.querySelectorAll('.error-message');
    errorElements.forEach(element => {
      element.remove();
    })
  }


}
